export const initialUsersState = {
    usersById: {},
    userIdsByProjectId: {},
};
